import React, { lazy } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
export function ProductPresentation() {
  const recipes = [{
    emoji: '🍫',
    name: 'Budín de chocolate'
  }, {
    emoji: '🍋',
    name: 'Budín de limón'
  }, {
    emoji: '🍌',
    name: 'Budín de banana'
  }, {
    emoji: '🥕',
    name: 'Budín de zanahoria'
  }, {
    emoji: '☕',
    name: 'Budín marmolado'
  }, {
    emoji: '🍯',
    name: 'Budín de vainilla'
  }, {
    emoji: '🍊',
    name: 'Budín de naranja'
  }, {
    emoji: '🥥',
    name: 'Budín de coco'
  }, {
    emoji: '🍏',
    name: 'Budín de manzana'
  }, {
    emoji: '🍰',
    name: 'y muchas recetas más'
  }];
  const differentiators = ['Recetas fáciles paso a paso', 'Ingredientes simples que puedes encontrar en cualquier supermercado', 'Consejos para lograr budines más esponjosos', 'Preparaciones rápidas para cualquier ocasión'];
  const occasions = [{
    emoji: '🍰',
    text: 'Meriendas'
  }, {
    emoji: '☕',
    text: 'Acompañar café o té'
  }, {
    emoji: '🎉',
    text: 'Reuniones con familia o amigos'
  }, {
    emoji: '🏠',
    text: 'Disfrutar algo rico hecho en casa'
  }];
  const accessFeatures = ['Descargarlo inmediatamente después de comprar', 'Verlo desde tu celular, tablet o computador', 'Guardarlo para usarlo cuando quieras'];
  const budinesImages = [{
    url: 'https://cdn.magicpatterns.com/uploads/83AFXVhEiW6XZkb3TjEtZM/ChatGPT_Image_17_mar_2026,_10_54_18.png',
    alt: 'Budín de limón glaseado'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/45HEtCbCWpCWdcUDeienKX/ChatGPT_Image_17_mar_2026,_10_56_06.png',
    alt: 'Budín marmolado'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/2G9hT8osF3oqLaJuKPVBwc/ChatGPT_Image_17_mar_2026,_10_57_33.png',
    alt: 'Budín de chocolate'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/uLdPvmj9pPuzqWrcWuiaTb/ChatGPT_Image_17_mar_2026,_10_59_46.png',
    alt: 'Budín con chips de chocolate'
  }];
  return <section className="py-20 px-4 bg-[#FEF3E2]" data-id="element-209">
      <div className="max-w-4xl mx-auto" data-id="element-210">
        {/* Recipes list */}
        <div className="mb-20" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-[#3D2B1F]" data-id="element-212">
            📘 Qué incluye este recetario
          </h2>
          <p className="text-xl text-[#6B5344] text-center mb-10" data-id="element-213">
            Podrás preparar budines como:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-214">
            {recipes.map((recipe, index) => <div key={index} className="bg-white p-4 rounded-xl border border-[#E8D5C4] flex items-center gap-3 shadow-sm" data-id="element-215">
                <span className="text-2xl" data-id="element-216">{recipe.emoji}</span>
                <span className="text-[#3D2B1F] font-medium text-lg" data-id="element-217">
                  {recipe.name}
                </span>
              </div>)}
          </div>

          {/* Image gallery */}
          <div className="grid grid-cols-2 gap-4 mt-10" data-id="element-218">
            {budinesImages.map((image, index) => <div key={index} className="overflow-hidden rounded-2xl shadow-lg" data-id="element-219">
                <img src={image.url} alt={image.alt} loading="lazy" className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300" data-id="element-220" />
              </div>)}
          </div>

          <p className="text-center text-[#9B8578] mt-6 text-lg" data-id="element-221">
            Todas explicadas de forma simple para que puedas hacerlas sin
            experiencia en repostería.
          </p>
        </div>

        {/* What makes it different */}
        <div className="mb-20" data-id="element-222">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-[#3D2B1F]" data-id="element-223">
            ✨ Lo que hace diferente este recetario
          </h2>
          <p className="text-xl text-[#6B5344] text-center mb-10" data-id="element-224">
            Este recetario fue creado para que cualquier persona pueda lograr
            budines perfectos sin complicaciones.
          </p>
          <div className="bg-white rounded-3xl p-8 md:p-10 border border-[#D4850A]/20 shadow-lg" data-id="element-225">
            <ul className="space-y-4 mb-8" data-id="element-226">
              {differentiators.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-227">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-228" />
                  <span className="text-lg text-[#3D2B1F]" data-id="element-229">{item}</span>
                </li>)}
            </ul>
            <div className="border-t border-[#E8D5C4] pt-6 space-y-2 text-center" data-id="element-230">
              <p className="text-lg text-[#6B5344]" data-id="element-231">
                No necesitas ser experto en cocina.
              </p>
              <p className="text-xl text-[#D4850A] font-medium italic" data-id="element-232">
                Solo seguir las recetas y disfrutar del resultado.
              </p>
            </div>
          </div>
        </div>

        {/* Perfect for any moment */}
        <div className="mb-20" data-id="element-233">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-[#3D2B1F]" data-id="element-234">
            ☕ Perfecto para cualquier momento
          </h2>
          <p className="text-xl text-[#6B5344] text-center mb-10" data-id="element-235">
            Con este recetario podrás preparar budines ideales para:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-236">
            {occasions.map((item, index) => <div key={index} className="bg-white p-5 rounded-xl border border-[#E8D5C4] flex items-center gap-4 shadow-sm" data-id="element-237">
                <span className="text-3xl" data-id="element-238">{item.emoji}</span>
                <span className="text-[#3D2B1F] font-medium text-lg" data-id="element-239">
                  {item.text}
                </span>
              </div>)}
          </div>
          <p className="text-center text-[#D4850A] mt-8 text-lg font-medium italic" data-id="element-240">
            Una vez que empieces a probar las recetas, vas a querer preparar
            budines todo el tiempo.
          </p>
        </div>

        {/* Immediate access */}
        <div className="mb-16" data-id="element-241">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-[#3D2B1F]" data-id="element-242">
            📱 Acceso inmediato
          </h2>
          <p className="text-xl text-[#6B5344] text-center mb-10" data-id="element-243">
            Este es un recetario digital, lo que significa que podrás:
          </p>
          <div className="bg-gradient-to-br from-white to-[#FEF3E2] rounded-3xl p-8 md:p-10 border border-[#D4850A]/20 relative overflow-hidden shadow-lg" data-id="element-244">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#D4850A]/5 rounded-full blur-3xl" data-id="element-245"></div>
            <ul className="space-y-5 relative z-10" data-id="element-246">
              {accessFeatures.map((item, index) => <li key={index} className="flex items-center gap-4" data-id="element-247">
                  <div className="bg-green-100 p-1 rounded-full" data-id="element-248">
                    <CheckCircle2Icon className="w-6 h-6 text-green-500" data-id="element-249" />
                  </div>
                  <span className="text-lg md:text-xl text-[#3D2B1F] font-medium" data-id="element-250">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="border-t border-[#E8D5C4] mt-8 pt-6 text-center space-y-2" data-id="element-251">
              <p className="text-lg text-[#6B5344]" data-id="element-252">
                No tendrás que esperar envíos.
              </p>
              <p className="text-xl text-[#3D2B1F] font-bold" data-id="element-253">
                Podrás empezar a preparar budines hoy mismo.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-254">
          <Button href="#compra" size="xl" data-id="element-255">
            👉 Descargar ahora el recetario
          </Button>
        </div>
      </div>
    </section>;
}